import request from '../api';
// 获取App会员权益分页列表
export function getAppMemberBenefitPage(data) {
  return request.post('/app/memberBenefit/getAppMemberBenefitPage', data);
}

// 获取App会员产品分页列表
export function getAppProductMemberPage(data) {
  return request.post('/app/productMember/getAppProductMemberPage', data);
}

// 创建微信二维码支付订单
export function createWxCodePayOrder(data) {
  return request.post('/app/order/createWxCodePayOrder', data);
}
// 积分购买
export function createPointPayOrder(data) {
  return request.post('/app/order/createPointPayOrder', data);
}

// 获取支付订单状态
export function getStatus(data) {
  return request.post('/app/orderPayment/getStatus', data);
}

// 获取功能套餐
export function getAppProductPackagePage(data) {
  return request({
    url: '/app/productPackage/getAppProductPackagePage',
    method: 'post',
    data,
  });
}
